<template>
  <div class="finance">
    <!-- 主要内容区 -->
    <main class="max-w-7xl mx-auto px-4 py-8">
      <!-- 财务概览 -->
      <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
        <div class="bg-white rounded-lg shadow-md p-6">
          <div class="flex items-center">
            <div class="p-3 rounded-full bg-green-100 text-green-600">
              <i class="fas fa-arrow-up text-xl"></i>
            </div>
            <div class="ml-4">
              <p class="text-gray-500">本月收入</p>
              <p class="text-2xl font-bold">¥234,567</p>
            </div>
          </div>
        </div>
        <div class="bg-white rounded-lg shadow-md p-6">
          <div class="flex items-center">
            <div class="p-3 rounded-full bg-red-100 text-red-600">
              <i class="fas fa-arrow-down text-xl"></i>
            </div>
            <div class="ml-4">
              <p class="text-gray-500">本月支出</p>
              <p class="text-2xl font-bold">¥45,678</p>
            </div>
          </div>
        </div>
        <div class="bg-white rounded-lg shadow-md p-6">
          <div class="flex items-center">
            <div class="p-3 rounded-full bg-blue-100 text-blue-600">
              <i class="fas fa-wallet text-xl"></i>
            </div>
            <div class="ml-4">
              <p class="text-gray-500">待结算</p>
              <p class="text-2xl font-bold">¥89,432</p>
            </div>
          </div>
        </div>
        <div class="bg-white rounded-lg shadow-md p-6">
          <div class="flex items-center">
            <div class="p-3 rounded-full bg-purple-100 text-purple-600">
              <i class="fas fa-chart-line text-xl"></i>
            </div>
            <div class="ml-4">
              <p class="text-gray-500">同比增长</p>
              <p class="text-2xl font-bold">+23.5%</p>
            </div>
          </div>
        </div>
      </div>

      <!-- 收支明细 -->
      <div class="bg-white rounded-lg shadow-md p-6 mb-8">
        <div class="flex justify-between items-center mb-6">
          <h2 class="text-xl font-bold">收支明细</h2>
          <div class="flex space-x-4">
            <select class="border rounded-lg px-4 py-2 focus:outline-none focus:border-yellow-500">
              <option>所有类型</option>
              <option>收入</option>
              <option>支出</option>
            </select>
            <button class="bg-gray-100 px-4 py-2 rounded-lg hover:bg-gray-200">
              <i class="fas fa-filter mr-2"></i>筛选
            </button>
          </div>
        </div>

        <!-- 收支列表 -->
        <div class="space-y-4">
          <!-- 收入项 -->
          <div class="flex items-center justify-between p-4 border rounded-lg">
            <div class="flex items-center">
              <div class="p-3 rounded-full bg-green-100 text-green-600 mr-4">
                <i class="fas fa-gift"></i>
              </div>
              <div>
                <h3 class="font-bold">礼物收入</h3>
                <p class="text-gray-600 text-sm">来自：小美直播间</p>
              </div>
            </div>
            <div class="text-right">
              <p class="font-bold text-green-600">+¥3,456</p>
              <p class="text-gray-600 text-sm">2024-03-21 14:30</p>
            </div>
          </div>

          <!-- 支出项 -->
          <div class="flex items-center justify-between p-4 border rounded-lg">
            <div class="flex items-center">
              <div class="p-3 rounded-full bg-red-100 text-red-600 mr-4">
                <i class="fas fa-coins"></i>
              </div>
              <div>
                <h3 class="font-bold">主播分成</h3>
                <p class="text-gray-600 text-sm">主播：阿杰</p>
              </div>
            </div>
            <div class="text-right">
              <p class="font-bold text-red-600">-¥1,234</p>
              <p class="text-gray-600 text-sm">2024-03-21 15:00</p>
            </div>
          </div>

          <!-- 收入项 -->
          <div class="flex items-center justify-between p-4 border rounded-lg">
            <div class="flex items-center">
              <div class="p-3 rounded-full bg-green-100 text-green-600 mr-4">
                <i class="fas fa-gift"></i>
              </div>
              <div>
                <h3 class="font-bold">礼物收入</h3>
                <p class="text-gray-600 text-sm">来自：小丽直播间</p>
              </div>
            </div>
            <div class="text-right">
              <p class="font-bold text-green-600">+¥2,345</p>
              <p class="text-gray-600 text-sm">2024-03-21 16:30</p>
            </div>
          </div>
        </div>
      </div>

      <!-- 财务报表 -->
      <div class="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <!-- 收入分析 -->
        <div class="bg-white rounded-lg shadow-md p-6">
          <div class="flex justify-between items-center mb-6">
            <h2 class="text-xl font-bold">收入分析</h2>
            <select class="border rounded-lg px-4 py-2 focus:outline-none focus:border-yellow-500">
              <option>最近7天</option>
              <option>最近30天</option>
              <option>最近90天</option>
            </select>
          </div>
          <div class="h-64 flex items-center justify-center bg-gray-50 rounded-lg">
            <p class="text-gray-500">收入趋势图表</p>
          </div>
        </div>

        <!-- 支出分析 -->
        <div class="bg-white rounded-lg shadow-md p-6">
          <div class="flex justify-between items-center mb-6">
            <h2 class="text-xl font-bold">支出分析</h2>
            <select class="border rounded-lg px-4 py-2 focus:outline-none focus:border-yellow-500">
              <option>最近7天</option>
              <option>最近30天</option>
              <option>最近90天</option>
            </select>
          </div>
          <div class="h-64 flex items-center justify-center bg-gray-50 rounded-lg">
            <p class="text-gray-500">支出趋势图表</p>
          </div>
        </div>
      </div>

      <!-- 结算管理 -->
      <div class="bg-white rounded-lg shadow-md p-6 mt-6">
        <div class="flex justify-between items-center mb-6">
          <h2 class="text-xl font-bold">结算管理</h2>
          <button class="bg-yellow-600 text-white px-4 py-2 rounded-lg hover:bg-yellow-700">
            <i class="fas fa-check mr-2"></i>批量结算
          </button>
        </div>

        <!-- 结算列表 -->
        <div class="space-y-4">
          <div class="flex items-center justify-between p-4 border rounded-lg">
            <div class="flex items-center">
              <img src="https://images.unsplash.com/photo-1494790108377-be9c29b29330?ixlib=rb-1.2.1&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80" alt="主播头像" class="w-10 h-10 rounded-full mr-4">
              <div>
                <h3 class="font-bold">小美</h3>
                <p class="text-gray-600 text-sm">待结算金额：¥12,345</p>
              </div>
            </div>
            <button class="bg-yellow-600 text-white px-4 py-2 rounded-lg hover:bg-yellow-700">
              结算
            </button>
          </div>

          <div class="flex items-center justify-between p-4 border rounded-lg">
            <div class="flex items-center">
              <img src="https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-1.2.1&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80" alt="主播头像" class="w-10 h-10 rounded-full mr-4">
              <div>
                <h3 class="font-bold">阿杰</h3>
                <p class="text-gray-600 text-sm">待结算金额：¥8,765</p>
              </div>
            </div>
            <button class="bg-yellow-600 text-white px-4 py-2 rounded-lg hover:bg-yellow-700">
              结算
            </button>
          </div>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
export default {
  name: 'FinancePage',
  data() {
    return {
      // 财务概览数据
      financeData: {
        monthlyIncome: 234567,
        monthlyExpense: 45678,
        pendingSettlement: 89432,
        growthRate: '+23.5%'
      }
    }
  }
}
</script>

<style scoped>
.finance {
  background: #f5f5f5;
  min-height: calc(100vh - 64px);
}

.grid {
  display: grid;
}

.grid-cols-1 {
  grid-template-columns: repeat(1, minmax(0, 1fr));
}

@media (min-width: 768px) {
  .md\:grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (min-width: 1024px) {
  .lg\:grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  
  .lg\:grid-cols-4 {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }
}

.gap-6 {
  gap: 1.5rem;
}

.mb-8 {
  margin-bottom: 2rem;
}

.mb-6 {
  margin-bottom: 1.5rem;
}

.mb-4 {
  margin-bottom: 1rem;
}

.mt-6 {
  margin-top: 1.5rem;
}

.p-6 {
  padding: 1.5rem;
}

.p-4 {
  padding: 1rem;
}

.p-3 {
  padding: 0.75rem;
}

.px-4 {
  padding-left: 1rem;
  padding-right: 1rem;
}

.py-2 {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}

.ml-4 {
  margin-left: 1rem;
}

.mr-4 {
  margin-right: 1rem;
}

.mr-2 {
  margin-right: 0.5rem;
}

.text-xl {
  font-size: 1.25rem;
}

.text-2xl {
  font-size: 1.5rem;
}

.font-bold {
  font-weight: 700;
}

.text-gray-500 {
  color: #6b7280;
}

.text-gray-600 {
  color: #4b5563;
}

.text-green-600 {
  color: #16a34a;
}

.text-red-600 {
  color: #dc2626;
}

.text-blue-600 {
  color: #2563eb;
}

.text-purple-600 {
  color: #9333ea;
}

.text-yellow-600 {
  color: #ca8a04;
}

.text-white {
  color: #ffffff;
}

.bg-green-100 {
  background-color: #dcfce7;
}

.bg-red-100 {
  background-color: #fee2e2;
}

.bg-blue-100 {
  background-color: #dbeafe;
}

.bg-purple-100 {
  background-color: #f3e8ff;
}

.bg-yellow-100 {
  background-color: #fef3c7;
}

.bg-gray-100 {
  background-color: #f3f4f6;
}

.bg-yellow-600 {
  background-color: #ca8a04;
}

.rounded-lg {
  border-radius: 0.5rem;
}

.rounded-full {
  border-radius: 9999px;
}

.shadow-md {
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
}

.border {
  border-width: 1px;
}

.focus\:outline-none:focus {
  outline: 2px solid transparent;
  outline-offset: 2px;
}

.focus\:border-yellow-500:focus {
  border-color: #ca8a04;
}

.hover\:bg-gray-200:hover {
  background-color: #e5e7eb;
}

.hover\:bg-yellow-700:hover {
  background-color: #a16207;
}

.text-sm {
  font-size: 0.875rem;
}

.space-y-4 > * + * {
  margin-top: 1rem;
}

.flex {
  display: flex;
}

.items-center {
  align-items: center;
}

.justify-between {
  justify-content: space-between;
}

.space-x-4 > * + * {
  margin-left: 1rem;
}

.relative {
  position: relative;
}

.text-right {
  text-align: right;
}

.h-64 {
  height: 16rem;
}

.w-10 {
  width: 2.5rem;
}

.h-10 {
  height: 2.5rem;
}

.object-cover {
  object-fit: cover;
}
</style> 